export default class Vendor {
    vendorNumber: number;
    vendorName: string;
    vendorName2: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    termNumber: number;
    phoneNumber: string;
    faxNumber: string;
    emailAddress: string;
    vendorAccount: string;
    contact: string;
    webPage: string;
    comments: string;
    taxId: string;
    isHidden: string;
    taxType: string;
    useSsn: string;
    isActive: number;
}


// WEBPACK FOOTER //
// ./src/models/AP/Vendor.ts